export default __webpack_public_path__ + "static/media/error-page-inner-bg-1.82fe4c26.png";